import Ui from 'services/Ui'

export default {
  computed: {

    dayFilter () {
      return this.$store.state.params.days
    },

    dayFilterLabel () {
      return Ui.label('time.filters', this.dayFilter)
    }
  },

  watch: {
    dayFilter() {
      this.update()
    }
  }
}
